import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useSnackbar } from "notistack";
//
const Admin = () => {
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [emptyFieldFilter, setEmptyFieldFilter] = useState("todos");
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [showBulkEdit, setShowBulkEdit] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [bulkValues, setBulkValues] = useState({
    local: "",
    tags: "",
    evento: "",
    atletaNome: "",
    priceInCents: "",
  });
  // Estados para atletas na edição em massa com filtro múltiplo
  const [atletas, setAtletas] = useState([]);
  const [filteredAtletas, setFilteredAtletas] = useState([]);
  const [selectedAtletas, setSelectedAtletas] = useState([]);
  const [searchAtleta, setSearchAtleta] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const getAuthHeaders = () => {
    const t =
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("adminToken") ||
      "";
    return t ? { Authorization: `Bearer ${t}` } : {};
  };
  const token =
    localStorage.getItem("token") || localStorage.getItem("authToken") || "";

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product`, {
        headers: getAuthHeaders(),
      })
      .then((response) => {
        setProduct(response.data.data);
        setFilteredProducts(response.data.data.reverse());

        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  const isAtletaEmpty = (p) => {
    const hasNome = Boolean(p.atletaNome && p.atletaNome.trim());
    const hasList = Boolean(
      Array.isArray(p.atletas) &&
        p.atletas.some((a) => a?.atletaNome && a.atletaNome.trim())
    );
    const hasId = Boolean(
      (p.atletaId && String(p.atletaId).trim()) ||
        (Array.isArray(p.atletasIds) && p.atletasIds.length > 0)
    );
    return !hasNome && !hasList && !hasId;
  };

  const isPrecoEmpty = (p) => {
    return (
      p.priceInCents == null ||
      p.priceInCents === "" ||
      Number(p.priceInCents) <= 0 ||
      Number.isNaN(Number(p.priceInCents))
    );
  };

  const isEventoEmpty = (p) => {
    return !p.evento || !p.evento.trim();
  };

  const isLocalEmpty = (p) => {
    return !p.local || !p.local.trim();
  };

  const isTagEmpty = (p) => {
    return !p.tags || !p.tags.trim();
  };

  const isAnyFieldEmpty = (p) => {
    return (
      isAtletaEmpty(p) ||
      isPrecoEmpty(p) ||
      isEventoEmpty(p) ||
      isLocalEmpty(p) ||
      isTagEmpty(p)
    );
  };

  const emptyCounts = {
    any: Array.isArray(product) ? product.filter(isAnyFieldEmpty).length : 0,
    atleta: Array.isArray(product) ? product.filter(isAtletaEmpty).length : 0,
    preco: Array.isArray(product) ? product.filter(isPrecoEmpty).length : 0,
    evento: Array.isArray(product) ? product.filter(isEventoEmpty).length : 0,
    local: Array.isArray(product) ? product.filter(isLocalEmpty).length : 0,
    tag: Array.isArray(product) ? product.filter(isTagEmpty).length : 0,
  };

  const filterProducts = () => {
    if (!Array.isArray(product)) {
      console.error("Products is not an array:", product);
      return;
    }

    let filtered = [...product];

    // 1. Filtro por campo vazio selecionado
    if (emptyFieldFilter !== "todos") {
      if (emptyFieldFilter === "algum_vazio") {
        filtered = filtered.filter(isAnyFieldEmpty);
      } else if (emptyFieldFilter === "atleta_vazio") {
        filtered = filtered.filter(isAtletaEmpty);
      } else if (emptyFieldFilter === "preco_vazio") {
        filtered = filtered.filter(isPrecoEmpty);
      } else if (emptyFieldFilter === "evento_vazio") {
        filtered = filtered.filter(isEventoEmpty);
      } else if (emptyFieldFilter === "local_vazio") {
        filtered = filtered.filter(isLocalEmpty);
      } else if (emptyFieldFilter === "tag_vazia") {
        filtered = filtered.filter(isTagEmpty);
      }
    }

    // 2. Filtro por termo de busca (preço, atleta, evento, local, tags)
    if (searchTerm.trim() !== "") {
      const cleanSearch = searchTerm.trim().toLowerCase();

      // Atalhos diretos digitados para campos vazios
      if (
        cleanSearch === "sem atleta" ||
        cleanSearch === "sem atletas" ||
        cleanSearch === "atleta vazio"
      ) {
        filtered = filtered.filter(isAtletaEmpty);
      } else if (
        cleanSearch === "sem preco" ||
        cleanSearch === "sem preço" ||
        cleanSearch === "preco vazio" ||
        cleanSearch === "preço vazio"
      ) {
        filtered = filtered.filter(isPrecoEmpty);
      } else if (
        cleanSearch === "sem evento" ||
        cleanSearch === "evento vazio"
      ) {
        filtered = filtered.filter(isEventoEmpty);
      } else if (
        cleanSearch === "sem local" ||
        cleanSearch === "local vazio"
      ) {
        filtered = filtered.filter(isLocalEmpty);
      } else if (
        cleanSearch === "sem tag" ||
        cleanSearch === "sem tags" ||
        cleanSearch === "tag vazia" ||
        cleanSearch === "tags vazias"
      ) {
        filtered = filtered.filter(isTagEmpty);
      } else if (
        cleanSearch === "vazio" ||
        cleanSearch === "vazios" ||
        cleanSearch === "em branco" ||
        cleanSearch === "sem dados"
      ) {
        filtered = filtered.filter(isAnyFieldEmpty);
      } else {
        const terms = cleanSearch
          .split(" ")
          .filter((term) => term !== "");

        filtered = filtered.filter((p) => {
          return terms.every((term) => {
            if (term === "sem_atleta" || term === "sem-atleta") return isAtletaEmpty(p);
            if (
              term === "sem_preco" ||
              term === "sem-preco" ||
              term === "sem_preço" ||
              term === "sem-preço"
            )
              return isPrecoEmpty(p);
            if (term === "sem_evento" || term === "sem-evento") return isEventoEmpty(p);
            if (term === "sem_local" || term === "sem-local") return isLocalEmpty(p);
            if (term === "sem_tag" || term === "sem-tag") return isTagEmpty(p);

            const eventoStr = (p.evento || "").toLowerCase();
            const localStr = (p.local || "").toLowerCase();
            const tagsStr = (p.tags || "").toLowerCase();
            const atletaNomeStr = (p.atletaNome || "").toLowerCase();
            const atletasListStr = Array.isArray(p.atletas)
              ? p.atletas
                  .map((a) => (a?.atletaNome || "").toLowerCase())
                  .join(" ")
              : "";

            const priceCentsStr =
              p.priceInCents != null ? String(p.priceInCents) : "";
            const priceReaisStr =
              p.priceInCents != null
                ? (p.priceInCents / 100).toFixed(2)
                : "";
            const priceReaisCommaStr = priceReaisStr.replace(".", ",");
            const priceIntegerStr =
              p.priceInCents != null
                ? String(Math.floor(p.priceInCents / 100))
                : "";

            return (
              eventoStr.includes(term) ||
              localStr.includes(term) ||
              tagsStr.includes(term) ||
              atletaNomeStr.includes(term) ||
              atletasListStr.includes(term) ||
              priceCentsStr.includes(term) ||
              priceReaisStr.includes(term) ||
              priceReaisCommaStr.includes(term) ||
              priceIntegerStr.includes(term)
            );
          });
        });
      }
    }
    setFilteredProducts(filtered);
  };

  useEffect(() => {
    filterProducts();
    // sempre que filtrar, reset de seleção
    setSelectedIds(new Set());
    setSelectAll(false);
  }, [product, searchTerm, emptyFieldFilter]);

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedIds(new Set());
      setSelectAll(false);
    } else {
      const allIds = new Set(filteredProducts.map((p) => p._id));
      setSelectedIds(allIds);
      setSelectAll(true);
    }
  };

  const toggleSelect = (id) => {
    const newSet = new Set(selectedIds);
    if (newSet.has(id)) {
      newSet.delete(id);
    } else {
      newSet.add(id);
    }
    setSelectedIds(newSet);
    setSelectAll(
      newSet.size === filteredProducts.length && filteredProducts.length > 0,
    );
  };

  const refreshProducts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product`,
        { headers: getAuthHeaders() },
      );
      setProduct(response.data.data);
      setFilteredProducts(response.data.data.reverse());
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Buscar atletas quando abrir o modal de edição em massa
  useEffect(() => {
    const fetchAtletas = async () => {
      try {
        if (!showBulkEdit) {
          setSelectedAtletas([]);
          setSearchAtleta("");
          return;
        }
        const headers = {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas`,
          headers,
        );
        const lista = response.data?.data || [];
        setAtletas(lista);
        setFilteredAtletas(lista);
      } catch (error) {
        console.error("Erro ao buscar atletas:", error);
      }
    };
    fetchAtletas();
  }, [showBulkEdit]);

  const handleSearchAtleta = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchAtleta(query);
    const filtered = atletas
      .filter((a) => (a.nome || "").toLowerCase().includes(query))
      .sort((a, b) => (a.nome || "").localeCompare(b.nome || ""));
    setFilteredAtletas(filtered);
  };

  const handleToggleAtleta = (atleta) => {
    setSelectedAtletas((prev) => {
      const exists = prev.some((a) => a._id === atleta._id);
      if (exists) {
        return prev.filter((a) => a._id !== atleta._id);
      } else {
        return [...prev, { _id: atleta._id, nome: atleta.nome }];
      }
    });
  };

  const parsePriceToCents = (val) => {
    if (val === "" || val == null) return null;
    const normalized = String(val)
      .replace(/[^\d,\.]/g, "")
      .replace(/\.(?=\d{3,})/g, "") // remove pontos de milhar
      .replace(",", ".");
    const num = Number(normalized);
    if (Number.isNaN(num)) return null;
    return Math.round(num * 100);
  };

  const handleBulkEditSubmit = async (e) => {
    e.preventDefault();
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const ids = Array.from(selectedIds);
    if (ids.length === 0) {
      enqueueSnackbar("Selecione ao menos um item", { variant: "info" });
      return;
    }
    try {
      setLoading(true);
      // Para cada produto selecionado, aplicar somente campos de texto informados
      const mapById = Object.fromEntries(product.map((p) => [p._id, p]));
      const newAtletaIds = selectedAtletas.map((a) => a._id);
      const newAtletaNomes = selectedAtletas
        .map((a) => a.nome)
        .filter(Boolean)
        .join(", ");
      const newAtletasList = selectedAtletas.map((a) => ({
        atletaId: a._id,
        atletaNome: a.nome,
      }));

      const requests = ids.map((id) => {
        const p = mapById[id];
        if (!p) return Promise.resolve();
        const payload = {
          // Campos obrigatórios para a rota de update
          local: bulkValues.local !== "" ? bulkValues.local : p.local,
          priceInCents:
            bulkValues.priceInCents !== ""
              ? (parsePriceToCents(bulkValues.priceInCents) ?? p.priceInCents)
              : p.priceInCents,
          evento: bulkValues.evento !== "" ? bulkValues.evento : p.evento,
          // Campos textuais opcionais
          tags: bulkValues.tags !== "" ? bulkValues.tags : p.tags,
          atletaNome:
            selectedAtletas.length > 0
              ? newAtletaNomes
              : (bulkValues.atletaNome !== ""
                ? bulkValues.atletaNome
                : p.atletaNome),
          // Preservar imagens/ids para não alterar links
          image: p.image,
          imageSample: p.imageSample,
          atletaId:
            selectedAtletas.length > 0
              ? (newAtletaIds[0] || null)
              : p.atletaId,
          atletasIds:
            selectedAtletas.length > 0
              ? newAtletaIds
              : (p.atletasIds || (p.atletaId ? [p.atletaId] : [])),
          atletas:
            selectedAtletas.length > 0
              ? newAtletasList
              : (p.atletas || (p.atletaNome ? [{ atletaId: p.atletaId, atletaNome: p.atletaNome }] : [])),
        };
        return axios.put(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product/${id}`,
          payload,
          headers,
        );
      });
      await Promise.all(requests);
      enqueueSnackbar("Itens atualizados com sucesso", { variant: "success" });
      setShowBulkEdit(false);
      setBulkValues({
        local: "",
        tags: "",
        evento: "",
        atletaNome: "",
        priceInCents: "",
      });
      setSelectedAtletas([]);
      setSearchAtleta("");
      setSelectedIds(new Set());
      setSelectAll(false);
      await refreshProducts();
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Falha ao atualizar itens", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleBulkDelete = async () => {
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const ids = Array.from(selectedIds);
    if (ids.length === 0) {
      enqueueSnackbar("Selecione ao menos um item", { variant: "info" });
      return;
    }
    try {
      setLoading(true);
      const requests = ids.map((id) =>
        axios.delete(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/product/${id}`,
          headers,
        ),
      );
      await Promise.all(requests);
      enqueueSnackbar("Itens excluídos com sucesso", { variant: "success" });
      setShowConfirmDelete(false);
      setSelectedIds(new Set());
      setSelectAll(false);
      await refreshProducts();
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Falha ao excluir itens", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-4 py-8 max-w-7xl mx-auto mt-16">
      {/* <Stats /> */}
      {/* Barra de filtros e ações em massa */}
      <div className="bg-base-200/50 p-4 rounded-xl border border-base-300 mb-6 shadow-sm">
        <div className="flex flex-col lg:flex-row items-stretch lg:items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 flex-1">
            <div className="form-control flex-1 max-w-md">
              <label className="label py-1">
                <span className="label-text text-xs font-semibold">Buscar fotos</span>
              </label>
              <div className="relative">
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Preço, atleta, evento, local ou tags..."
                  className="input input-bordered input-sm sm:input-md w-full pr-8"
                />
                {searchTerm && (
                  <button
                    type="button"
                    onClick={() => setSearchTerm("")}
                    className="absolute right-2.5 top-1/2 -translate-y-1/2 text-xs opacity-60 hover:opacity-100"
                    title="Limpar busca"
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>

            <div className="form-control min-w-[210px]">
              <label className="label py-1">
                <span className="label-text text-xs font-semibold">Filtrar por campos vazios</span>
              </label>
              <select
                value={emptyFieldFilter}
                onChange={(e) => setEmptyFieldFilter(e.target.value)}
                className="select select-bordered select-sm sm:select-md w-full"
              >
                <option value="todos">Todos os itens ({product.length})</option>
                <option value="algum_vazio">
                  ⚠️ Algum campo vazio ({emptyCounts.any})
                </option>
                <option value="atleta_vazio">
                  Sem Atleta ({emptyCounts.atleta})
                </option>
                <option value="preco_vazio">
                  Sem Preço ({emptyCounts.preco})
                </option>
                <option value="evento_vazio">
                  Sem Evento ({emptyCounts.evento})
                </option>
                <option value="local_vazio">
                  Sem Local ({emptyCounts.local})
                </option>
                <option value="tag_vazia">
                  Sem Tag ({emptyCounts.tag})
                </option>
              </select>
            </div>

            {(searchTerm || emptyFieldFilter !== "todos") && (
              <button
                type="button"
                onClick={() => {
                  setSearchTerm("");
                  setEmptyFieldFilter("todos");
                }}
                className="btn btn-sm btn-ghost self-end sm:self-auto mt-auto mb-1 text-xs"
              >
                Limpar filtros
              </button>
            )}
          </div>

          <div className="flex gap-2 items-center justify-between sm:justify-end border-t lg:border-t-0 pt-3 lg:pt-0 border-base-300">
            <span className="text-sm font-medium">
              Selecionados: <span className="badge badge-neutral">{selectedIds.size}</span>
            </span>
            <div className="flex gap-2">
              <button
                className="btn btn-sm btn-warning text-white"
                disabled={selectedIds.size === 0}
                onClick={() => setShowBulkEdit(true)}
              >
                Editar ({selectedIds.size})
              </button>
              <button
                className="btn btn-sm btn-error text-white"
                disabled={selectedIds.size === 0}
                onClick={() => setShowConfirmDelete(true)}
              >
                Excluir
              </button>
            </div>
          </div>
        </div>

        {/* Pílulas rápidas para filtrar por vazios com um clique */}
        <div className="flex flex-wrap items-center gap-1.5 mt-3 pt-3 border-t border-base-300/60 text-xs">
          <span className="font-semibold opacity-70 mr-1">Filtros rápidos de vazios:</span>
          <button
            type="button"
            onClick={() => setEmptyFieldFilter(emptyFieldFilter === "atleta_vazio" ? "todos" : "atleta_vazio")}
            className={`btn btn-xs ${emptyFieldFilter === "atleta_vazio" ? "btn-primary" : "btn-outline"} gap-1`}
          >
            Sem Atleta <span className="badge badge-xs">{emptyCounts.atleta}</span>
          </button>
          <button
            type="button"
            onClick={() => setEmptyFieldFilter(emptyFieldFilter === "preco_vazio" ? "todos" : "preco_vazio")}
            className={`btn btn-xs ${emptyFieldFilter === "preco_vazio" ? "btn-primary" : "btn-outline"} gap-1`}
          >
            Sem Preço <span className="badge badge-xs">{emptyCounts.preco}</span>
          </button>
          <button
            type="button"
            onClick={() => setEmptyFieldFilter(emptyFieldFilter === "evento_vazio" ? "todos" : "evento_vazio")}
            className={`btn btn-xs ${emptyFieldFilter === "evento_vazio" ? "btn-primary" : "btn-outline"} gap-1`}
          >
            Sem Evento <span className="badge badge-xs">{emptyCounts.evento}</span>
          </button>
          <button
            type="button"
            onClick={() => setEmptyFieldFilter(emptyFieldFilter === "local_vazio" ? "todos" : "local_vazio")}
            className={`btn btn-xs ${emptyFieldFilter === "local_vazio" ? "btn-primary" : "btn-outline"} gap-1`}
          >
            Sem Local <span className="badge badge-xs">{emptyCounts.local}</span>
          </button>
          <button
            type="button"
            onClick={() => setEmptyFieldFilter(emptyFieldFilter === "tag_vazia" ? "todos" : "tag_vazia")}
            className={`btn btn-xs ${emptyFieldFilter === "tag_vazia" ? "btn-primary" : "btn-outline"} gap-1`}
          >
            Sem Tag <span className="badge badge-xs">{emptyCounts.tag}</span>
          </button>
          <button
            type="button"
            onClick={() => setEmptyFieldFilter(emptyFieldFilter === "algum_vazio" ? "todos" : "algum_vazio")}
            className={`btn btn-xs ${emptyFieldFilter === "algum_vazio" ? "btn-warning" : "btn-outline"} gap-1`}
          >
            Qualquer Vazio <span className="badge badge-xs">{emptyCounts.any}</span>
          </button>
          <span className="opacity-60 ml-auto text-[11px]">
            Exibindo {filteredProducts.length} de {product.length} itens
          </span>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="table">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={selectAll}
                  onChange={toggleSelectAll}
                  aria-label="Selecionar todos"
                />
              </th>
              <th>
                <Link
                  to="/admin/product/create"
                  className="bg-green-600 hover:bg-green-900 py-2 px-4 font-medium rounded-lg 
                              shadow-md text-base-100"
                >
                  Novo
                </Link>
              </th>
              <th>Local</th>
              <th>Preço</th>
              <th>Tags</th>
              <th>Atleta</th>
              <th>Evento</th>
            </tr>
          </thead>

          <tbody>
            {filteredProducts.map((product, index) => (
              <tr key={product._id} className="bg-base-100 hover:bg-base-300">
                <td>
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={selectedIds.has(product._id)}
                    onChange={() => toggleSelect(product._id)}
                    aria-label={`Selecionar produto ${product._id}`}
                  />
                </td>
                <td>
                  <div className="avatar">
                    <div className="w-16 h-16">
                      <img src={product.imageSample} alt={product.title} />
                    </div>
                  </div>
                </td>
                <td className="py-3 px-5">
                  {product.local || (
                    <span className="badge badge-ghost badge-sm text-xs opacity-50 italic">
                      Sem local
                    </span>
                  )}
                </td>
                <td className="py-3 px-5">
                  {product.priceInCents != null &&
                  product.priceInCents !== "" &&
                  Number(product.priceInCents) > 0 ? (
                    product.priceInCents
                  ) : (
                    <span className="badge badge-ghost badge-sm text-xs opacity-50 italic">
                      Sem preço
                    </span>
                  )}
                </td>
                <td className="py-3 px-5">
                  {product.tags && product.tags.trim() ? (
                    product.tags
                  ) : (
                    <span className="badge badge-ghost badge-sm text-xs opacity-50 italic">
                      Sem tag
                    </span>
                  )}
                </td>
                <td className="py-3 px-5">
                  {product.atletaNome ||
                    (Array.isArray(product.atletas) &&
                      product.atletas
                        .map((a) => a.atletaNome)
                        .filter(Boolean)
                        .join(", ")) || (
                      <span className="badge badge-ghost badge-sm text-xs opacity-50 italic">
                        Sem atleta
                      </span>
                    )}
                </td>
                <td className="py-3 px-5">
                  {product.evento || (
                    <span className="badge badge-ghost badge-sm text-xs opacity-50 italic">
                      Sem evento
                    </span>
                  )}
                </td>
                <td className="py-3 px-5">
                  <div className="flex justify-center gap-x-1">
                    <Link
                      to={`/admin/product/edit/${product._id}`}
                      className="bg-orange-500 hover:bg-orange-900
                 text-white py-2 px-4 font-medium rounded-l-lg text-sm"
                    >
                      Editar
                    </Link>

                    <Link
                      to={`/admin/product/delete/${product._id}`}
                      className="bg-red-500 hover:bg-red-900
                 text-white py-2 px-4 font-medium rounded-r-lg text-sm"
                    >
                      Remover
                    </Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal de edição em massa (somente textos) */}
      {showBulkEdit && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-base-100 p-6 rounded-lg shadow-xl w-full max-w-xl">
            <h3 className="text-lg font-semibold mb-4">
              Editar textos (em massa)
            </h3>
            <p className="text-sm opacity-70 mb-3">
              Preencha apenas os campos que deseja aplicar aos itens
              selecionados. Campos em branco serão mantidos conforme o original
              de cada item.
            </p>
            <form onSubmit={handleBulkEditSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Local</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    value={bulkValues.local}
                    onChange={(e) =>
                      setBulkValues((v) => ({ ...v, local: e.target.value }))
                    }
                    placeholder="(deixe em branco para manter)"
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Tags</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    value={bulkValues.tags}
                    onChange={(e) =>
                      setBulkValues((v) => ({ ...v, tags: e.target.value }))
                    }
                    placeholder="(deixe em branco para manter)"
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Evento</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    value={bulkValues.evento}
                    onChange={(e) =>
                      setBulkValues((v) => ({ ...v, evento: e.target.value }))
                    }
                    placeholder="(deixe em branco para manter)"
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Preço (em reais)</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    value={bulkValues.priceInCents}
                    onChange={(e) =>
                      setBulkValues((v) => ({
                        ...v,
                        priceInCents: e.target.value,
                      }))
                    }
                    placeholder="Ex.: 15,90 (deixe em branco para manter)"
                  />
                </div>
                <div className="form-control md:col-span-2 border border-base-300 rounded-lg p-3 bg-base-200/40">
                  <div className="flex items-center justify-between mb-1">
                    <label className="label-text font-medium">
                      Atletas <span className="text-xs font-normal opacity-70">(pode selecionar mais de um - deixe vazio para manter)</span>
                    </label>
                    {selectedAtletas.length > 0 && (
                      <button
                        type="button"
                        onClick={() => setSelectedAtletas([])}
                        className="text-xs text-error hover:underline font-semibold"
                      >
                        Limpar seleção ({selectedAtletas.length})
                      </button>
                    )}
                  </div>

                  {selectedAtletas.length > 0 && (
                    <div className="flex flex-wrap gap-1.5 mb-2">
                      {selectedAtletas.map((a) => (
                        <span
                          key={a._id}
                          className="badge badge-primary gap-1 py-3 px-2 text-xs"
                        >
                          {a.nome}
                          <button
                            type="button"
                            onClick={() => handleToggleAtleta(a)}
                            className="hover:text-red-300 ml-1 font-bold"
                            title="Remover"
                          >
                            ✕
                          </button>
                        </span>
                      ))}
                    </div>
                  )}

                  <input
                    type="text"
                    className="input input-bordered input-sm mb-2 w-full"
                    value={searchAtleta}
                    onChange={handleSearchAtleta}
                    placeholder="Buscar atletas para marcar..."
                  />

                  <div className="max-h-36 overflow-y-auto border border-base-300 rounded-md p-2 bg-base-100 divide-y divide-base-200">
                    {filteredAtletas.length > 0 ? (
                      filteredAtletas.map((a) => {
                        const isChecked = selectedAtletas.some(
                          (item) => item._id === a._id
                        );
                        return (
                          <label
                            key={a._id}
                            className="flex items-center gap-2 py-1.5 px-1 hover:bg-base-200 rounded cursor-pointer text-sm"
                          >
                            <input
                              type="checkbox"
                              className="checkbox checkbox-sm checkbox-primary"
                              checked={isChecked}
                              onChange={() => handleToggleAtleta(a)}
                            />
                            <span className="font-medium">{a.nome}</span>
                            {a.perfil && (
                              <span className="text-[11px] opacity-60 ml-auto">
                                {a.perfil}
                              </span>
                            )}
                          </label>
                        );
                      })
                    ) : (
                      <div className="text-xs text-center py-2 opacity-60">
                        Nenhum atleta encontrado
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="mt-6 flex justify-end gap-2">
                <button
                  type="button"
                  className="btn"
                  onClick={() => {
                    setShowBulkEdit(false);
                    setSelectedAtletas([]);
                    setSearchAtleta("");
                  }}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn btn-warning"
                  disabled={loading}
                >
                  Aplicar aos selecionados
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de confirmação para exclusão em massa */}
      {showConfirmDelete && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-base-100 p-6 rounded-lg shadow-xl w-full max-w-md">
            <h3 className="text-lg font-semibold mb-4">Confirmar exclusão</h3>
            <p className="mb-4">
              Você está prestes a excluir {selectedIds.size} item(s). Esta ação
              irá remover o documento no Mongo e as imagens no Cloudinary (como
              na exclusão individual). Deseja continuar?
            </p>
            <div className="flex justify-end gap-2">
              <button
                className="btn"
                onClick={() => setShowConfirmDelete(false)}
              >
                Cancelar
              </button>
              <button
                className="btn btn-error"
                onClick={handleBulkDelete}
                disabled={loading}
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;
